import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="top-right"
      visibleToasts={1}
      expand={false}
      closeButton
      richColors
      duration={4000}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast !rounded-xl !border !px-4 !py-3 !shadow-lg !font-medium !text-sm",
          title: "!font-semibold",
          description: "!text-sm !opacity-90",
          success:
            "!bg-emerald-50 !text-emerald-900 !border-emerald-300 [&_[data-icon]]:!text-emerald-600",
          error:
            "!bg-red-50 !text-red-900 !border-red-300 [&_[data-icon]]:!text-red-600",
          info: "!bg-sky-50 !text-sky-900 !border-sky-300 [&_[data-icon]]:!text-sky-600",
          closeButton: "!border-border !bg-background !text-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
